import React from "react";
import { Snackbar, SnackbarContent, makeStyles } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { connect } from "react-redux";
import { ToasterInfo } from "../store/types/ux";
import { IDRaksStore } from "../store/store";
import { uxActions } from "../store/actions/ux.actions";
import {
  faCheckCircle,
  faInfoCircle,
  faExclamationTriangle
} from "@fortawesome/pro-solid-svg-icons";

interface ToasterProps {
  options: ToasterInfo;
  onHide: Function;
}

export const Toaster = (props: ToasterProps) => {
  const { options, onHide } = props;

  const colors = {
    success: "#43a047",
    info: "#3f51b5",
    warning: "#ffa000",
    error: "#d32f2f"
  };

  const icons = {
    success: faCheckCircle,
    info: faInfoCircle,
    warning: faExclamationTriangle,
    error: faInfoCircle
  };

  const useStyles = makeStyles({
    root: {
      backgroundColor: colors[options.variant]
    },
    message: {
      color: "white",
      fontSize: "16px",
      fontFamily: "Ubuntu",
      display: "flex",
      alignItems: "center",
      whiteSpace: "pre-wrap"
    }
  });
  const classes = useStyles();

  const useIconStyles = makeStyles({
    icon: {
      marginRight: "8px"
    }
  });
  const iconClasses = useIconStyles();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: options.vertical,
        horizontal: options.horizontal
      }}
      open={options.open}
      onClose={() => onHide()}
      autoHideDuration={3000}
    >
      <SnackbarContent
        classes={classes}
        message={
          <span className="snackbar">
            <FontAwesomeIcon
              icon={icons[options.variant] as IconProp}
              className={iconClasses.icon}
            />
            {options.message}
          </span>
        }
      />
    </Snackbar>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    options: store.ux.toaster
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onHide: () => dispatch(uxActions.hideToaster())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
